(function () {
  'use strict';

  // ── Toast ────────────────────────────────────────────────────────────

  let toastEl = null;
  let toastTimer = null;

  function getToast() {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cart-2voor-toast';
      document.body.appendChild(toastEl);
    }
    return toastEl;
  }

  function showToast(savingsCents) {
    const toast = getToast();
    const amount = formatMoney(parseInt(savingsCents, 10));
    toast.textContent = '🎉 You save ' + amount + '!';
    toast.classList.add('is-visible');

    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 4500);
  }

  // Minimal money formatter — mirrors Shopify's euro convention
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + amount;
  }

  // ── Size pre-selection ───────────────────────────────────────────────

  function syncSizes() {
    var upsell = document.querySelector('.cart-2voor-upsell');
    if (!upsell) return;

    var currentSize = upsell.dataset.currentSize;
    if (!currentSize) return;

    upsell.querySelectorAll('.cart-2voor-upsell__tile').forEach(function (tile) {
      var matched = false;
      tile.querySelectorAll('.cart-2voor-upsell__size-btn').forEach(function (btn) {
        var match = btn.textContent.trim() === currentSize && !btn.disabled;
        btn.classList.toggle('is-selected', match);
        if (match) matched = true;
      });
      if (!matched) {
        tile.querySelectorAll('.cart-2voor-upsell__size-btn').forEach(function (btn) {
          btn.classList.remove('is-selected');
        });
      }
    });
  }

  // ── Dot carousel ────────────────────────────────────────────────────

  function initDots() {
    var upsell = document.querySelector('.cart-2voor-upsell');
    if (!upsell) return;

    var scroll = upsell.querySelector('.cart-2voor-upsell__scroll');
    var grid   = upsell.querySelector('.cart-2voor-upsell__grid');
    var dots   = upsell.querySelectorAll('.cart-2voor-upsell__dot');
    if (!scroll || !dots.length) return;

    function getTiles() {
      return grid.querySelectorAll('.cart-2voor-upsell__tile');
    }

    function getInlinePadding() {
      return parseInt(getComputedStyle(scroll).paddingInlineStart, 10) || 0;
    }

    function getTileWidth() {
      var tiles = getTiles();
      if (tiles.length > 1) {
        var w = tiles[1].getBoundingClientRect().left - tiles[0].getBoundingClientRect().left;
        if (w > 0) return w;
      }
      var w2 = tiles[0] ? tiles[0].offsetWidth : 0;
      return w2 > 0 ? w2 + 20 : 160;
    }

    // Click a dot → scroll to that tile
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var tileWidth = getTileWidth();
        scroll.scrollTo({ left: i * tileWidth, behavior: 'smooth' });
      });
    });

    // Scroll → update active dot (debounced so snap settles first on iOS)
    var scrollTimer = null;
    function updateActiveDot() {
      var tileWidth = getTileWidth();
      var idx = tileWidth > 0 ? Math.round(scroll.scrollLeft / tileWidth) : 0;
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }
    scroll.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateActiveDot, 80);
    }, { passive: true });
  }

  // ── Completed progress bar ───────────────────────────────────────────

  function showCompletedProgress(upsell) {
    var progress = upsell.querySelector('.cart-2voor-progress');
    if (!progress) return;

    var barWrap = progress.querySelector('.cart-2voor-progress__bar-wrap');
    var label   = progress.querySelector('.cart-2voor-progress__bar-label');
    var topText = progress.querySelector('.cart-2voor-progress__top-text');
    var cta     = progress.querySelector('.cart-2voor-progress__cta');

    if (barWrap) {
      barWrap.setAttribute('aria-valuenow', '2');
      barWrap.setAttribute('aria-label', '2/2');
    }
    if (label)   label.textContent  = '2/2';
    if (topText) topText.textContent = '2 producten toegevoegd!';
    if (cta) {
      var savings = parseInt(upsell.dataset.savings, 10);
      cta.innerHTML = '🎉 Gelukt! Je bespaart <span class="cart-2voor-upsell__amount">' + formatMoney(savings) + '</span>';
    }

    progress.classList.add('is-complete');
  }

  // ── Qty-based completion ─────────────────────────────────────────────

  var savedDealSavings = null;

  var ICON_SVG = '<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="m16.558 4.8.884.884-9.959 9.958-4.925-4.925.884-.884 4.041 4.041z"/></svg>';

  function injectCompletedBar(savings) {
    var cartItemsEl = document.getElementById('cart-items');
    if (!cartItemsEl) return;

    var existing = cartItemsEl.querySelector('.cart-2voor-upsell');
    if (existing) existing.remove();

    var amount = formatMoney(parseInt(savings, 10));
    var wrapper = document.createElement('div');
    wrapper.className = 'cart-2voor-upsell';
    wrapper.innerHTML =
      '<div class="cart-2voor-progress">' +
        '<div class="cart-2voor-progress__top">' +
          '<span class="cart-2voor-progress__icon">' + ICON_SVG + '</span>' +
          '<span class="cart-2voor-progress__top-text">2 producten toegevoegd!</span>' +
        '</div>' +
        '<div class="cart-2voor-progress__bar-wrap" role="progressbar" aria-valuenow="2" aria-valuemin="0" aria-valuemax="2" aria-label="2/2">' +
          '<div class="cart-2voor-progress__bar-fill"></div>' +
          '<span class="cart-2voor-progress__bar-label">2/2</span>' +
        '</div>' +
        '<p class="cart-2voor-progress__cta">' +
          '🎉 Gelukt! Je bespaart <span class="cart-2voor-upsell__amount">' + amount + '</span>' +
        '</p>' +
      '</div>';

    var liveRegion = cartItemsEl.querySelector('#cart-live-region-text');
    if (liveRegion) {
      cartItemsEl.insertBefore(wrapper, liveRegion);
    } else {
      cartItemsEl.appendChild(wrapper);
    }

    // Add is-complete after two frames so the bar width transition fires (55% → 100%)
    var progress = wrapper.querySelector('.cart-2voor-progress');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        progress.classList.add('is-complete');
      });
    });
  }

  // Capture savings on + button click (fires before BundleSuite intercepts the click)
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[name="plus"].qty-input__btn');
    if (!btn) return;

    var upsell = document.querySelector('.cart-2voor-upsell[data-savings]');
    if (!upsell) return; // no deal upsell visible means cart doesn't qualify

    // Only save when current qty is 1 (clicking + takes it to 2)
    var input = btn.closest('quantity-input') && btn.closest('quantity-input').querySelector('[name="updates[]"]');
    var currentQty = input ? parseInt(input.value, 10) : -1;
    console.log('[2voor] plus-click: currentQty =', currentQty);

    if (currentQty === 1) {
      savedDealSavings = upsell.dataset.savings;
      console.log('[2voor] plus-click: savedDealSavings =', savedDealSavings);
    }
  }, true); // capture phase — fires before BundleSuite and quantity-input.js

  // Also capture on qty input change (for non-BundleSuite path)
  document.addEventListener('change', function (evt) {
    if (!evt.target.matches('[name="updates[]"]')) return;
    var newQty = parseInt(evt.target.value, 10);
    console.log('[2voor] capture: qty input changed to', newQty);
    if (newQty >= 2) {
      var upsell = document.querySelector('.cart-2voor-upsell[data-savings]');
      if (upsell) {
        savedDealSavings = upsell.dataset.savings;
        console.log('[2voor] capture: savedDealSavings =', savedDealSavings);
      } else {
        console.log('[2voor] capture: no .cart-2voor-upsell[data-savings] in DOM');
      }
    } else {
      savedDealSavings = null;
    }
  }, true); // capture phase — runs before any bubble listener

  // ── Add to cart ──────────────────────────────────────────────────────

  function addVariantToCart(variantId, upsell, addBtn) {
    addBtn.disabled = true;
    addBtn.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        showCompletedProgress(upsell);
        showToast(upsell.dataset.savings);
        setTimeout(function () {
          document.dispatchEvent(
            new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true })
          );
        }, 1500);
      })
      .catch(function (err) {
        console.error('[2-voor upsell] add failed:', err);
        addBtn.disabled = false;
        addBtn.textContent = 'ADD';
      });
  }

  // ── Event delegation (survives cart drawer re-renders) ───────────────

  document.addEventListener('click', function (evt) {
    // Size button toggle
    var sizeBtn = evt.target.closest('.cart-2voor-upsell__size-btn');
    if (sizeBtn && !sizeBtn.disabled) {
      var tile = sizeBtn.closest('.cart-2voor-upsell__tile');
      tile.querySelectorAll('.cart-2voor-upsell__size-btn').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      sizeBtn.classList.add('is-selected');
      return;
    }

    // ADD button
    var addBtn = evt.target.closest('.cart-2voor-upsell__add-btn');
    if (!addBtn) return;

    var tile   = addBtn.closest('.cart-2voor-upsell__tile');
    var upsell = addBtn.closest('.cart-2voor-upsell');
    var selected = tile.querySelector('.cart-2voor-upsell__size-btn.is-selected');

    if (!selected) {
      var sizesRow = tile.querySelector('.cart-2voor-upsell__sizes');
      sizesRow.style.outline = '2px solid rgb(var(--sale-price-color, 200 0 0))';
      setTimeout(function () { sizesRow.style.outline = ''; }, 1200);
      return;
    }

    addVariantToCart(selected.dataset.variantId, upsell, addBtn);
  });

  // ── MutationObserver — fires when bundle app re-renders cart without
  //    dispatching on:line-item:change ──────────────────────────────────

  var mutationTimer = null;

  function onCartDomChanged() {
    if (!savedDealSavings) return;
    console.log('[2voor] MutationObserver triggered, savedDealSavings =', savedDealSavings);
    if (document.querySelector('.cart-2voor-progress.is-complete')) {
      savedDealSavings = null;
      return;
    }
    var savings = savedDealSavings;
    savedDealSavings = null; // clear first — prevents re-entry when injectCompletedBar mutates DOM
    setTimeout(function () {
      if (!document.querySelector('.cart-2voor-progress.is-complete')) {
        injectCompletedBar(savings);
      }
    }, 150);
  }

  function setupCartObserver() {
    // Prefer cart-drawer element; fall back to body so we catch any re-render
    var target = document.querySelector('cart-drawer') ||
                 document.getElementById('cart-items') ||
                 document.body;
    var observer = new MutationObserver(function () {
      clearTimeout(mutationTimer);
      mutationTimer = setTimeout(onCartDomChanged, 100);
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  // ── Init & re-init hooks ─────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', function () {
    syncSizes();
    initDots();
    setupCartObserver();
  });

  document.addEventListener('on:line-item:change', function (evt) {
    var cartData = evt.detail && evt.detail.cart;
    console.log('[2voor] on:line-item:change fired', cartData && cartData.items);

    // Relaxed condition: any total qty ≥ 2 across all items (handles both
    // qty=2 on one item AND bundle app creating 2 separate line items)
    if (savedDealSavings &&
        cartData && cartData.items &&
        !document.querySelector('.cart-2voor-progress.is-complete')) {
      var totalQty = 0;
      cartData.items.forEach(function (item) { totalQty += item.quantity; });
      if (totalQty >= 2) {
        var savings = savedDealSavings;
        savedDealSavings = null;
        injectCompletedBar(savings);
      }
    }
    if (savedDealSavings) savedDealSavings = null;

    setTimeout(function () {
      syncSizes();
      initDots();
    }, 50);
  });

  document.addEventListener('dispatch:cart-drawer:refresh', function () {
    setTimeout(function () {
      syncSizes();
      initDots();
    }, 300);
  });

})();
